import { configureStore } from "@reduxjs/toolkit";
import flowDesignerReducer from "./features/flowdesigner/flowdesigner.slice";
import sidebarReducer from "./features/sidebar/sidebar.slice";
import striimAiReducer from "./features/striim-ai/striim-ai.slice";

const store = configureStore({
    reducer: {
        flowDesigner: flowDesignerReducer,
        sidebar: sidebarReducer,
        striimAi: striimAiReducer
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ["flowDesigner/setAppModelAction"],
                ignoredPaths: ["flowDesigner.appModel"]
            }
        })
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
